export enum Type {
  FINANCIAMENTO = 'FINANCIAMENTO',
  TERRENO = 'TERRENO',
}
